
import React from 'react';
import "./Header.css"
import {GiSawedOffShotgun} from 'react-icons/gi';


const Header = () => {
    return (
        <nav>
        <h1>Welcome To My Gun Shope<GiSawedOffShotgun/> </h1>
           </nav>
    );
};

export default Header;